$(document).ready(function(){
  function updateStorageDisplay(input_val) {
    $('.care_product_value').each(function(){
      var variant_size = $(this).attr('variant_size').trim();
      if(input_val == variant_size){
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  }
  var initial_val = $('input[name="Storage"]:checked').val();
  updateStorageDisplay(initial_val);
  $('.Storage_picker').click(function(){
    var input_val = $(this).attr('var_title_1').trim();
    updateStorageDisplay(input_val);
  });
     $('.care_product_value').on('click', function() {
    var $checkbox = $(this).find('input[type="checkbox"]');
    $('.care_product_value input[type="checkbox"]').not($checkbox).prop('checked', false);
    
    if ($checkbox.is(':checked')) {
        $checkbox.prop('checked', false);
        $('.product-form__buttons').show();
        $('.Custom_add_to_cart_bose_care').hide();
        $(this).removeClass('checkedInput');
    } else {
        $checkbox.prop('checked', true);
        $('.product-form__buttons').hide();
        $('.Custom_add_to_cart_bose_care').show();
        $(this).addClass('checkedInput').siblings().removeClass('checkedInput');
    }
});
  $('body').on('click','input', function() {
 $(this).parent().trigger('click');
});
    $('.Custom_add_to_cart_bose_care').click(function() {
    var main_product_id = $(this).parents('.product-form').find('.product-variant-id').val();
    var care_product_id = $('.care_product_value input[name="care"]:checked').val();
    var quantity = $(this).parents('.product-form').find('.quantity__input').val();
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    if (!care_product_id) {
        alert('Please select a care product.');
        return;
    }

    let formdata = {
        items: [
            {
                'id': care_product_id,
                'quantity': quantity
            },
            {
                'id': main_product_id,
                'quantity': quantity,
                'properties': { 'Care_main': care_product_id }
            }
        ],
        sections: this.cart.getSectionsToRender().map((section) => section.id)
    };

    fetch('/cart/add.js', {
        method: "POST",
        headers: { 'Content-Type': "application/json" },
        body: JSON.stringify(formdata)
    })
    .then(response => response.json())
    .then(response => this.cart.renderContents(response))
    .catch(error => console.error('Error:', error))
    .finally(() => {
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
    });
});

$('body').on('click','.remove_cstm_btn', function() {
    var remove_val = $(this).attr('remove_product').trim();
    var remove_main = $(this).attr('main_product').trim();
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    let formdata = {
        updates: {
            [remove_val]: 0,
            [remove_main]: 0
        },
        sections: this.cart.getSectionsToRender().map((section) => section.id)
    };

    fetch('/cart/update.js', {
        method: "POST",
        headers: { 'Content-Type': "application/json" },
        body: JSON.stringify(formdata)
    })
    .then(response => response.json())
    .then(response => this.cart.renderContents(response))
    .catch(error => console.error('Error:', error))
    .finally(() => {
            if (this.cart && this.cart.classList.contains('drawer')) this.cart.classList.add('is-empty');
    });
});


});